import service from './request';

export function submitLead(data: { company: string; name: string; phone: string; email?: string; service: string }) {
  return service.post('/api/front/leads', data);
}
